// @ts-nocheck
export default (value1: any, value2: any) => value1 === value2;
